import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="120"
    height="138"
    viewBox="0 0 120 138"
    fill="none"
  >
    <ellipse cx="30.5" cy="115.5" rx="20.5" ry="7.5" fill="#FF8569" />
    <rect x="49" y="109" width="2" height="7" fill="#FF8569" />
    <rect x="10" y="109" width="2" height="7" fill="#FF8569" />
    <ellipse cx="30.5" cy="109.5" rx="20.5" ry="7.5" fill="#FFC2B4" />
    <ellipse cx="89.5" cy="115.5" rx="20.5" ry="7.5" fill="#FF8569" />
    <rect x="102" y="104" width="8" height="12" fill="#FF8569" />
    <rect x="69" y="104" width="9" height="12" fill="#FF8569" />
    <ellipse cx="89.5" cy="104.5" rx="20.5" ry="7.5" fill="#FFC2B4" />
    <path
      d="M85.397 27.5782C85.397 27.5782 88.5767 32.3937 89.0472 34.5894C89.5178 36.7851 92.968 47.2144 98.9277 44.5482C104.887 41.8821 107.161 38.3533 106.377 34.8247C105.593 31.296 101.026 29.5849 99.428 26.0883L91.9174 23.0375L85.397 27.5782Z"
      fill="#3E3432"
    />
    <path
      d="M84.5518 24.5168C84.5518 24.5168 85.761 19.2798 88.3413 19.2798C90.9214 19.2798 93.0131 21.3714 93.0131 23.9516C93.0131 25.9771 91.7504 27.692 89.948 28.3398C89.948 28.3398 84.6962 27.8437 84.5518 24.5168Z"
      fill="#F8A991"
    />
    <path
      d="M89.9478 19.5634C88.1591 20.2185 86.8827 21.936 86.8827 23.9516C86.8827 25.9672 88.1591 27.6847 89.9478 28.3398C89.4468 28.5233 88.9057 28.6235 88.341 28.6235C85.7609 28.6235 83.6692 26.5318 83.6692 23.9517C83.6692 22.3058 84.539 20.8484 85.825 20.0162C85.8251 20.016 89.4469 19.3799 89.9478 19.5634Z"
      fill="#F6987C"
    />
    <path
      d="M101.463 21.1781L102.906 23.0055L103.906 23.0376L105.99 23.1043L107.018 20.1664C107.338 19.2521 107.067 18.2607 106.384 17.6337C106.225 17.4862 106.043 17.3606 105.841 17.2593C105.5 17.0887 105.136 17.0067 104.779 17.0067C103.852 17.0067 102.964 17.5543 102.584 18.4725L101.463 21.1781Z"
      fill="#F8A991"
    />
    <path
      d="M85.3966 31.845H88.6101C87.0558 31.845 85.7948 33.106 85.7948 34.6615V47.5748H82.5814V34.6614C82.5814 33.1059 83.8424 31.845 85.3966 31.845Z"
      fill="#FFB09E"
    />
    <path
      d="M82.5811 47.5747L75.061 58.9416C73.6939 61.0079 74.0595 63.7658 75.9178 65.4046L85.8626 74.1746L88.0781 73.0731L89.4312 70.6606L81.9474 62.1208L89.7507 53.5015V47.5746L86.1043 45.584L82.5811 47.5747Z"
      fill="#62DBFB"
    />
    <path
      d="M75.061 58.9417L82.5812 47.5747L84.4021 46.546L85.7947 47.5747L78.2745 58.9417C76.9075 61.008 77.2731 63.7659 79.1313 65.4047L87.3808 72.6798L87.4902 73.3655L85.8625 74.1747L75.9179 65.4047C74.0596 63.7659 73.694 61.008 75.061 58.9417Z"
      fill="#01D0FB"
    />
    <path
      d="M91.0356 71.7401L89.4312 70.6607L85.8626 74.1747L86.759 79.2714C86.9078 80.1174 87.6426 80.7343 88.5015 80.7343H88.838C89.6351 80.7343 90.334 80.2012 90.5445 79.4323L92.036 73.9858C92.2382 73.178 91.9125 72.33 91.2215 71.8652L91.0356 71.7401Z"
      fill="#EAF6FF"
    />
    <path
      d="M94.036 47.5746L90.2927 45.9691L86.4767 47.5746L80.6892 60.2362C80.4969 60.6568 80.3975 61.1139 80.3975 61.5765C80.3975 63.2506 81.6789 64.6462 83.3469 64.7887L95.51 65.8283L96.792 63.4447L96.285 61.2571L89.5849 59.5899C89.0666 59.4609 88.8594 58.8358 89.1983 58.4229L92.1654 54.8056C93.4081 53.2907 94.0774 51.3866 94.0561 49.4273L94.036 47.5746Z"
      fill="#62DBFB"
    />
    <path
      d="M80.6893 60.2364L86.4768 47.5748L88.5947 46.5461L89.6902 47.5748L83.9027 60.6212C83.6316 61.0905 83.5822 61.4257 83.611 61.9614C83.611 63.348 84.4904 64.5428 85.7402 64.9936L83.3469 64.789C81.6789 64.6465 80.3975 63.2509 80.3975 61.5768C80.3975 61.1141 80.4971 60.657 80.6893 60.2364Z"
      fill="#01D0FB"
    />
    <path
      d="M95.51 65.8285L97.5206 69.93C97.8177 70.5362 98.4342 70.9205 99.1094 70.9205C100.087 70.9205 100.879 70.1283 100.879 69.1511V63.4317C100.879 62.3958 100.079 61.5354 99.0459 61.4595L98.9524 61.4527L96.285 61.2571L95.51 65.8285Z"
      fill="#EAF6FF"
    />
    <path
      d="M71.0104 19.598L71.3118 22.8501L74.6666 24.3749L76.1862 22.2372L75.7348 19.0453C75.6553 18.4798 75.3796 17.9835 74.9846 17.6245C74.5614 17.236 73.9985 17.0026 73.3868 17H73.3778C71.9786 17 70.8808 18.2029 71.0104 19.598Z"
      fill="#F8A991"
    />
    <path
      d="M71.0104 19.598L71.3118 22.8501L74.6666 24.3749L74.5255 22.8501L74.2242 19.598C74.1523 18.8235 74.4588 18.1093 74.9846 17.6258V17.6245C74.5614 17.236 73.9985 17.0026 73.3868 17H73.3778C71.9787 17 70.8809 18.2029 71.0104 19.598Z"
      fill="#F6987C"
    />
    <path
      d="M86.8086 20.3334L87.2404 22.1571C88.3057 23.2783 90.0827 24.4907 92.9267 24.8445L94.8662 29.9501L99.4279 26.0882C99.4279 26.0882 94.9577 19.4808 89.6414 19.1005L86.8086 20.3334Z"
      fill="#544542"
    />
    <path
      d="M87.2406 22.1571C86.1806 21.0415 85.8252 20.0161 85.8252 20.0161C87.5728 18.9931 89.3201 18.8981 90.9523 19.3197C89.2712 19.5363 87.8701 20.6452 87.2406 22.1571Z"
      fill="#3E3432"
    />
    <path
      d="M85.3967 31.845L82.5814 39.2796L74.2403 33.338C72.9105 32.3895 72.0588 30.9104 71.9083 29.2836L74.4883 22.4515L76.1861 22.2374L76.9872 27.8981C77.0521 28.3562 77.3223 28.7596 77.7214 28.9938L81.5868 31.2624C82.2383 31.6437 82.9791 31.8451 83.734 31.8451L85.3967 31.845Z"
      fill="#FE5694"
    />
    <path
      d="M71.3118 22.8503L71.9081 29.2839C72.0581 30.91 72.9109 32.3899 74.2407 33.3375L82.5813 39.2801L83.2636 37.4772L77.4532 33.3377C76.1234 32.39 75.2719 30.9102 75.1218 29.2841L74.4883 22.4515L71.3118 22.8503Z"
      fill="#FD3581"
    />
    <path
      d="M82.5814 34.6608C82.5814 33.1056 83.8423 31.8447 85.3975 31.8447H90.2513C91.785 31.8447 93.2713 31.301 94.4421 30.3097L96.1258 28.8837L98.9611 26.4831C99.2676 26.224 99.5087 25.8944 99.6613 25.5238L101.463 21.1778L104.193 22.3396L104.195 22.3408L105.99 23.1039L104.442 27.5294C104.006 28.7746 103.28 29.8967 102.321 30.8034L99.0087 33.9362L94.527 38.1706C94.2133 38.467 94.0355 38.8794 94.0355 39.311V47.5744L85.7947 47.5746L82.5813 41.1067L84.7562 38.8922L82.5813 35.9556V34.6608H82.5814Z"
      fill="#FE5694"
    />
    <path
      d="M85.3967 31.845H88.6102C87.0559 31.845 85.7949 33.106 85.7949 34.6615V47.5748H82.5814V34.6614C82.5814 33.1058 83.8424 31.845 85.3967 31.845Z"
      fill="#FD3581"
    />
    <path
      d="M35.5999 41.5101C35.5999 41.5101 34.3907 36.2731 31.8104 36.2731C29.2303 36.2731 27.1387 38.3647 27.1387 40.9448C27.1387 42.9704 28.4013 44.6853 30.2038 45.3331C30.2038 45.3331 35.4555 44.837 35.5999 41.5101Z"
      fill="#FFCEBF"
    />
    <path
      d="M30.2039 36.5567C31.9926 37.2119 33.269 38.9293 33.269 40.9449C33.269 42.9605 31.9926 44.678 30.2039 45.3331C30.705 45.5166 31.2461 45.6168 31.8107 45.6168C34.3908 45.6168 36.4825 43.5252 36.4825 40.9451C36.4825 39.2992 35.6127 37.8418 34.3267 37.0096C34.3266 37.0093 30.7048 36.3732 30.2039 36.5567Z"
      fill="#FFB09E"
    />
    <path
      d="M18.6886 38.1714L17.2458 39.9987L16.2456 40.0309L14.1618 40.0976L13.1334 37.1597C12.8141 36.2454 13.0847 35.254 13.7681 34.627C13.927 34.4795 14.1092 34.3539 14.3106 34.2526C14.6517 34.082 15.0159 34 15.3724 34C16.2995 34 17.1882 34.5476 17.5679 35.4658L18.6886 38.1714Z"
      fill="#FFCEBF"
    />
    <path
      d="M34.7551 48.8383H31.5416C33.0959 48.8383 34.3569 50.0993 34.3569 51.6548V64.5681H37.5704V51.6547C37.5704 50.0992 36.3094 48.8383 34.7551 48.8383Z"
      fill="#FFB09E"
    />
    <path
      d="M37.5706 64.568L45.0908 75.9348C46.4578 78.0012 46.0922 80.7591 44.234 82.3979L34.2892 91.1678L32.0737 90.0664L30.7205 87.6539L38.2043 79.1141L30.401 70.4948V64.5678L34.0474 62.5773L37.5706 64.568Z"
      fill="#60818A"
    />
    <path
      d="M45.0907 75.9349L37.5705 64.568L35.7496 63.5392L34.3571 64.568L41.8772 75.9349C43.2443 78.0013 42.8787 80.7592 41.0204 82.398L32.7709 89.6731L32.6615 90.3588L34.2892 91.1679L44.2339 82.398C46.0921 80.7592 46.4577 78.0013 45.0907 75.9349Z"
      fill="#556D74"
    />
    <path
      d="M29.1162 88.7334L30.7205 87.654L34.2891 91.168L33.3927 96.2647C33.244 97.1107 32.5092 97.7276 31.6502 97.7276H31.3138C30.5166 97.7276 29.8178 97.1945 29.6073 96.4256L28.1157 90.9791C27.9136 90.1712 28.2392 89.3233 28.9302 88.8585L29.1162 88.7334Z"
      fill="#D3E5F3"
    />
    <path
      d="M26.1157 64.568L29.859 62.9624L33.675 64.568L39.4625 77.2296C39.6548 77.6502 39.7543 78.1073 39.7543 78.5698C39.7543 80.244 38.4986 81.2046 37.1517 82.4933L29.6418 89.8216L28.3597 87.4381L28.8668 85.2504L32.1517 78.4933C32.6517 77.4933 31.2923 75.8291 30.9535 75.4162L27.9863 71.7989C26.7436 70.284 26.0743 68.3799 26.0956 66.4206L26.1157 64.568Z"
      fill="#60818A"
    />
    <path
      d="M39.4625 77.2297L33.675 64.5681L31.557 63.5394L30.4615 64.5681L36.249 77.6145C36.5201 78.0838 37.1804 78.9576 37.1517 79.4933C37.1517 80.8799 37.1517 81.9933 36.1517 83.4933L37.6517 82.4933C39.4625 81.1671 39.7543 80.2443 39.7543 78.5701C39.7543 78.1075 39.6547 77.6504 39.4625 77.2297Z"
      fill="#556D74"
    />
    <path
      d="M30.3674 89.51L29.0125 93.8723C28.8123 94.5171 28.2624 94.9917 27.5953 95.0957C26.6298 95.2462 25.725 94.5855 25.5745 93.62L24.6936 87.9688C24.534 86.9452 25.1915 85.9719 26.2008 85.7379L26.2921 85.7167L28.8976 85.1126L30.3674 89.51Z"
      fill="#EAF6FF"
    />
    <path
      d="M53.7056 46.7545L51.6552 49.2967L48.0171 48.7106L47.934 46.0891L50.076 43.6801C50.4551 43.2531 50.9594 42.9922 51.4871 42.9117C52.0546 42.8222 52.6526 42.9393 53.1636 43.2755L53.171 43.2805C54.3365 44.0546 54.5855 45.664 53.7056 46.7545Z"
      fill="#FFCEBF"
    />
    <path
      d="M53.7055 46.7544L51.6551 49.2966L48.017 48.7106L48.9781 47.5185L51.0285 44.9763C51.5169 44.3709 51.6568 43.6063 51.4863 42.9127L51.487 42.9116C52.0545 42.8222 52.6525 42.9392 53.1635 43.2755L53.171 43.2804C54.3365 44.0546 54.5854 45.664 53.7055 46.7544Z"
      fill="#FFB09E"
    />
    <path
      d="M33.3432 37.3267L32.9114 39.1504C31.846 40.2716 30.0691 41.484 27.2251 41.8378L26.6517 39.9933L26.1518 37.9933C26.1518 37.9933 27.1518 36.4933 30.5104 36.0938L33.3432 37.3267Z"
      fill="#EE8B43"
    />
    <path
      d="M32.9112 39.1504C33.9711 38.0348 37.6518 35.4933 37.6518 35.4933C32.1518 34.9933 30.8316 35.8914 29.1994 36.313C30.8805 36.5296 32.2817 37.6385 32.9112 39.1504Z"
      fill="#EE6F14"
    />
    <path
      d="M34.9458 48.9963L33.1774 56.7469L43.4129 56.4127C45.0455 56.3583 46.5733 55.5975 47.5988 54.3256L49.2297 47.2071L47.9339 46.0894L44.1346 50.3614C43.8271 50.7071 43.3788 50.8936 42.9168 50.8679L38.4417 50.619C37.6881 50.5761 36.9596 50.334 36.3308 49.9163L34.9458 48.9963Z"
      fill="#9DD820"
    />
    <path
      d="M51.655 49.2967L47.5987 54.3259C46.574 55.5975 45.0449 56.3583 43.4128 56.4119L33.1772 56.7473L33.6064 54.8679L40.7368 54.6346C42.3688 54.581 43.8969 53.8194 44.9216 52.5479L49.2297 47.207L51.655 49.2967Z"
      fill="#84B61A"
    />
    <path
      d="M37.5704 51.6542C37.5704 50.0989 36.3095 48.8381 34.7542 48.8381H29.9004C28.3667 48.8381 26.8804 48.2943 25.7097 47.3031L24.0259 45.877L21.1906 43.4764C20.8842 43.2174 20.643 42.8877 20.4904 42.5172L18.6887 38.1711L15.9584 39.3329L15.9572 39.3342L14.1618 40.0972L15.7096 44.5228C16.1457 45.768 16.8714 46.89 17.8306 47.7968L21.1431 50.9296L25.6248 55.1639C25.9385 55.4603 26.1162 55.8727 26.1162 56.3043V64.5677L34.357 64.568L37.5705 58.1001L35.3955 55.8855L37.5705 52.9489V51.6542H37.5704Z"
      fill="#9DD820"
    />
    <path
      d="M34.755 48.8383H31.5416C33.0958 48.8383 34.3568 50.0993 34.3568 51.6548V64.5681H37.5703V51.6547C37.5703 50.0992 36.3093 48.8383 34.755 48.8383Z"
      fill="#84B61A"
    />
  </SvgIcon>
));
